import { RESET_RESPONSE_APPOINTMENT } from "./types";
import {
  SET_APPOINTMENT_DETAILS,
  SET_APPOINTMENT_LOADED,
  FETCH_APPOINTMENT_DETAILS
} from "./types";

const initialState = {
  Application_Number: "",
  isLoaded: false,
  AppointmentBookings: []
};

const appointmentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APPOINTMENT_LOADED:
      return { 
        ...state,
        isLoaded: payload,
        }
    case SET_APPOINTMENT_DETAILS:
      return { 
        ...state,
        Application_Number:  payload?.Application_Number,
        AppointmentBookings: [...state?.AppointmentBookings, ...payload?.Insured_Info],
        isLoaded: true,
        }
    case FETCH_APPOINTMENT_DETAILS:
      return { 
        ...state,
        Application_Number:  payload?.Application_Number,
        AppointmentBookings: [...payload?.Insured_Info],
        isLoaded: true,
        }
    case RESET_RESPONSE_APPOINTMENT:
      return { ...initialState }
    default:
      return state;
  }
};

export default appointmentReducer;
